<div class="step-content">
    <div class="header-section pad-2">
        <button class="back-link" (click)="onBack()">
            ← Enter your TIN to search for adding location.
        </button>
    </div>
    <div class="location-mainouter">
        <div class="location-controls">
            <div class="search-box">
                <label class="control-label">Search TIN</label>
                <div class="input-wrapper">
                    <app-text-input [for] = "'search-Input'" [placeholder]="'Search'"
                    (keypress)="restrictNonNumeric($event)" [fieldType]="'TIN'"
                    [control]="tinForm.controls['TIN']"
                    [errorMessages]="errormsg('TIN')" [maxLength]="9"> </app-text-input>
                    <img alt="search" src="../../../../../assets/images/unsubmit-search.svg"  class="search-icon">
                </div>
                <button class="btn add-location-btn searchTINBtn" (click)="searchTIN()"
                [disabled]="(!tinForm.get('TIN')?.value || tinForm.controls['TIN'].errors)">Search</button>
            </div>
        </div>
 <hr>
        <div class="table-container desktop-only" #tableWrapper>
          <table class="location-table" *ngIf="locations && locations.length >0">
            <thead>
            <tr>
            <th class="select-column">Select</th>
            <th>Location Name</th>
            <th>Address</th>
            <th>City</th>
            <th>State</th>
            <th>Zip</th>
            </tr>
            </thead>
             
            <tbody>
            <tr *ngFor="let location of displayedLocations">
            <td class="select-column">
            @if(isSearchLocationAlreadyExists(location)) {
            <span class="existing-indicator" aria-label="Existing location" title="Location already added">Existing</span>
            } @else {
            <mat-radio-button
            color="primary"
            name="selectedLocation"
            [value]="location.locationId"
            [checked]="selectedLocationId === location.locationId"
            (change)="selectedLocationId = location.locationId"></mat-radio-button>
            }
            </td>             
            <td>{{ location.name ? location.name : location.locationName }}</td>
            <td>{{ location.address1 }}</td>
            <td>{{ location.city }}</td>
            <td>{{ location.state }}</td>
            <td>{{ location.zip }}</td>
            </tr>
            </tbody>
            </table> 
            <div *ngIf="locations && locations.length > 0">
                <mat-paginator [length]="totalRecords" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page"
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>            
            <div class="bottom-section" *ngIf="locations && locations.length >0">
                <div></div>
                <button class="btn add-location-btn" [disabled]="!selectedLocationId" (click)="onProceed()">
                Proceed
                </button>
            </div>
            @if(locations && locations.length >0){
            <ng-container *ngTemplateOutlet="showNewLocationbtn"></ng-container>
            }
          @if(searchDone && locations.length ==0){
            <div class="text-center no-data-msg">
                @if(tinErrorMessage == "TIN doesn't exists, please proceed to add your TIN"){
                    <div class="tinNotExist">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="80" height="80">
                            <!-- Soft green circular background -->
                            <circle cx="50" cy="50" r="42" fill="#CAEBCC" />
                            <!-- Magnifying glass lens -->
                            <circle cx="44" cy="44" r="15" fill="none" stroke="#2DB035" stroke-width="3" />
                            <!-- Magnifying glass handle (shorter & thinner) -->
                            <line x1="55" y1="55" x2="67" y2="67" stroke="#2DB035" stroke-width="3.5" stroke-linecap="round" />
                            <!-- Plus icon vertical line -->
                            <line x1="44" y1="36" x2="44" y2="52" stroke="#2DB035" stroke-width="2.5" stroke-linecap="round" />
                            <!-- Plus icon horizontal line -->
                            <line x1="36" y1="44" x2="52" y2="44" stroke="#2DB035" stroke-width="2.5" stroke-linecap="round" />
                        </svg>
                        <h3>This TIN isn't on file yet</h3>
                        <p class="tinErrMsg">We couldn't find <b>{{searchedTIN}}</b> in our system. </p>
                        <button class="btn add-location-btn proceedNoData" (click)="onAddTin()">Add this TIN</button>                        
                        <p class="tinErrMsg">We'll walk you through entering the location, payee, and tax details.</p>
                    </div>
                    }
                @if(tinErrorMessage == "No locations found for this TIN."){
                    <div class="noLocationFound">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="80" height="80">
                            <!-- Soft green circular background -->
                            <circle cx="50" cy="50" r="42" fill="#CAEBCC" />
                            <!-- Magnifying glass lens -->
                            <circle cx="44" cy="44" r="15" fill="none" stroke="#2DB035" stroke-width="3" />
                            <!-- Magnifying glass handle (shorter & thinner) -->
                            <line x1="55" y1="55" x2="67" y2="67" stroke="#2DB035" stroke-width="3.5" stroke-linecap="round" />
                        </svg>
                        <h3>No locations found for this TIN</h3>
                        <p class="tinErrMsg">We couldn't find any locations associated with <b>{{searchedTIN}} for your state</b> in our system. </p>
                    </div>
                    }
            </div>
            @if(tinErrorMessage == "No locations found for this TIN."){
            <ng-container *ngTemplateOutlet="showNewLocationbtn"></ng-container>
            }
            }
        </div>
        <ng-template #showNewLocationbtn>
            <div class="bottom-section location-add-banner">
                <div class="location-add-banner-content">
                    <svg class="location-point-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" aria-hidden="true">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <div class="location-add-banner-text">
                        <h3>Don't see your location?</h3>
                        <p>If your practice location isn't listed above, add it manually and we'll attach it to this TIN.</p>
                    </div>
                </div>
                <button type="button" class="btn btn-primary add-location-btn" (click)="GoToNewLocationPage()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Add new location
                </button>
            </div>
        </ng-template>
 </div>
</div>